module.exports = __webpack_public_path__ + "4d844e9c1071d9b75f1880744351b394.pdf";